import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { AiOutlineLock } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "../footer";
import { useTranslations } from "../../translations";

/**
 * Pantalla mostrada en un módulo de IA cuando el usuario no tiene suscripción activa.
 * Solo se usa cuando el bloqueo está activado (flag REACT_APP_AI_PAYWALL_ENFORCE).
 */
const AiPaywall = () => {
  const navigate = useNavigate();
  const { t } = useTranslations();
  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content pb-5">
        <Container fluid className="py-4 mx-auto" style={{ maxWidth: 640 }}>
          <Card className="text-center p-4 shadow-sm border-0" style={{ borderRadius: 16 }}>
            <Card.Body>
              <AiOutlineLock size={56} style={{ color: "#6c5ce7" }} />
              <h4 className="mt-3 mb-2">{t("paywallTitle")}</h4>
              <p className="text-muted mb-4">{t("paywallText")}</p>
              <Button variant="primary" size="lg" onClick={() => navigate("/subscription")}>
                {t("paywallButton")}
              </Button>
            </Card.Body>
          </Card>
        </Container>
        <Footer logged={true} />
      </main>
    </div>
  );
};

export default AiPaywall;
